"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentHelper = void 0;
var envConfig_1 = require("../envConfig");
exports.EnvironmentHelper = {
    isClientSide: function () {
        return (typeof window === "object" &&
            window != null &&
            typeof document === "object" &&
            document != null);
    },
    isServerSide: function () {
        return !exports.EnvironmentHelper.isClientSide();
    },
    isLocalDevelopmentEnvironment: function () {
        return envConfig_1.COMMON_ENV_CONFIG.ENV_NAME === "local_development";
    },
    isLocalProductionEnvironment: function () {
        return envConfig_1.COMMON_ENV_CONFIG.ENV_NAME === "local_production";
    },
    isProductionEnvironment: function () {
        return envConfig_1.COMMON_ENV_CONFIG.ENV_NAME === "production";
    },
    isLocalEnvironment: function () {
        return (this.isLocalDevelopmentEnvironment() ||
            this.isLocalProductionEnvironment());
    },
    isRunningTest: function () {
        return envConfig_1.COMMON_ENV_CONFIG.NODE_ENV === "test";
    },
};
